import { useState, useEffect } from "react";
import Typography from "@material-ui/core/Typography";
import { Grid, Button, makeStyles } from "@material-ui/core";
import TextareaAutosize from "@material-ui/core/TextareaAutosize";
import Divider from "@material-ui/core/Divider";
import Link from "@material-ui/core/Link";
import { GetLink, GetMessage, GetPracticeName, updateReviews } from "../../../../../../api/PE_API";
import { Box, Rating } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";

// Update log
// FB  6192   02/06/2023  DK  Page to upload the reviews post appointment

export default function Reviews(props: any) {
    var appt_n = 0;
    var { id } = useParams();
    if (id != undefined) {
        appt_n = Number(id);
    }

    var appt_flag = "";
    var { flag } = useParams();
    if (flag != undefined) {
        appt_flag = flag;
    }

    const [ratingValue, setRatingValue] = useState<number | null>(0);
    const [displayMessage, setDisplayMessage] = useState("none");
    const [displaylink, setDisplaylink] = useState("none");
    const [displayTextarea, setdisplayTextarea] = useState("none");
    const [displaySend, setDisoplaysend] = useState("none");
    const [displaySubmit, setDisoplaysubmit] = useState("flex");
    const [message, setMessage] = useState("");
    const [googlelink, setGoogleLink] = useState("");
    const [freezeStars, setfreezeStars] = useState(false);
    const [comments, setComments] = useState("");
    const [practiceName, setPracticeName] = useState("");
    const onload = async () => {
        const data = await GetPracticeName();
        setPracticeName(data);
    }
    const buttonClick = async () => {
        const data = await GetMessage(ratingValue, appt_n);
        setfreezeStars(true);
        setMessage(data);
        if (ratingValue !== null) {
            if (ratingValue <= 3) {
                setDisplayMessage("flex");
                setDisplaylink("none");
                setdisplayTextarea("flex");
                setDisoplaysend("flex");
                setDisoplaysubmit("none");
            }
            if (ratingValue >= 4) {
                const data = await GetLink(appt_n, appt_flag);
                setGoogleLink(data);
                setDisplayMessage("none");
                setDisplaylink("flex");
                setdisplayTextarea("none");
                setDisoplaysend("none");
                setDisoplaysubmit("none");
                updateReviews(ratingValue, comments, appt_n);
            }
            if (ratingValue == 0) {
                setDisplayMessage("none");
                setDisplaylink("none");
                setdisplayTextarea("none");
                setDisoplaysend("none");
            }
        } else {
            setDisplayMessage("none");
            setDisplaylink("none");
            if (ratingValue == 0) {
                setDisplayMessage("none");
                setDisplaylink("none");
            }
        }
    };
    const useStyles = makeStyles({
        active: {
            backgroundColor: "#18a2b8",
            color: "white",
            textTransform: "capitalize",
            borderRadius: "15px",
            marginLeft: "20px",
            "&:hover": {
                backgroundColor: "#18a2b8",
            },
        },
    });
    const classes = useStyles();
    const navigate = useNavigate();
    const sendButtonClick = () => {
        updateReviews(ratingValue, comments, appt_n);
        navigate("/Thankyou/" + appt_n);
    };

    useEffect(() => {
        onload();
    }, []);

    return (
        <Box
            sx={{
                width: "100%",
                padding: window.innerWidth < 800 ? "24px 20px" : "24px 80px"
            }}>
            <Grid container>
                <Grid
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    <h1 style={{ color: "gray" }}>Satisfaction Survey</h1>
                </Grid>
            </Grid>
            <Divider />
            <Grid container>
                <Grid
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    <Typography variant="h6" component="legend">
                        Please rate your recent visit at {practiceName}
                    </Typography>
                </Grid>
            </Grid>
            <br />
            <Grid container>
                <Grid
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    <Rating
                        name="customized-empty"
                        defaultValue={0}
                        // precision={0.5}
                        size="large"
                        onChange={(event, newValue) => {
                            setRatingValue(newValue);
                        }}
                        readOnly={freezeStars}
                        style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    />
                </Grid>
            </Grid>
            <br />
            <Grid
                container
                spacing={1}
                style={{
                    display: "flex",
                    justifyContent: "center",
                }}
            >
                <Grid
                    item
                    xs={6}
                    sm={6}
                    md={2}
                    lg={2}
                    style={{
                        display: displaySubmit,
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <Button
                        variant="contained"
                        className={classes.active}
                        onClick={buttonClick}
                    >
                        Submit
                    </Button>
                </Grid>
            </Grid>
            <br />
            <div style={{ display: displayTextarea }}>
                <Grid container>
                    <Grid
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                        style={{
                            display: displayMessage,
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        <Typography variant="h6">{message}</Typography>
                    </Grid>
                    <Grid
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                        style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        <TextareaAutosize
                            aria-label="minimum height"
                            style={{ width: "400px", borderColor: "gray" }}
                            rowsMin={8}
                            placeholder="Feedback"
                            onChange={(e) => setComments(e.target.value)}
                        />
                    </Grid>
                </Grid>
            </div>

            <Grid container>
                <Grid
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    style={{
                        display: displaylink,
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    <p>
                        <span>{message}</span>
                        <span>
                            <Link
                                style={{ fontSize: "20px" }}
                                href={googlelink}
                            >
                                Click Here
                            </Link>
                        </span>

                    </p>
                </Grid>
            </Grid>
            <Grid
                container
                spacing={1}
                style={{
                    display: "flex",
                    justifyContent: "flex-end",
                }}
            >
                <Grid
                    item
                    xs={6}
                    sm={6}
                    md={2}
                    lg={2}
                    style={{
                        display: displaySend,
                        justifyContent: "flex-end",
                        alignItems: "center",
                    }}
                >
                    <Button
                        variant="contained"
                        className={classes.active}
                        onClick={sendButtonClick}
                    >
                        Send
                    </Button>
                </Grid>
            </Grid>
        </Box>
    );
};